import ConsumoModal from "./ConsumoModal";
export default ConsumoModal;